import { Directive } from '@angular/core';
import {
   LcsChipMultiSelectTextContentFn,
   LcsChipMultiSelectTriggerComponent,
} from 'src/app/common-components/multi-select/chip-multi-select-trigger.component';
import { UserOption } from 'src/app/pages/user-register/models/user-option.interface';

@Directive({
    selector: 'lcs-chip-multi-select-trigger[ndtUserMultiSelect]',
    standalone: false
})
export class UserChipMultiSelectTriggerDirective {
   constructor(trigger: LcsChipMultiSelectTriggerComponent<UserOption>) {
      trigger.getDisplayText = entityChipMultiSelectText(trigger);
   }
}

export function entityChipMultiSelectText<T = UserOption>(
   // eslint-disable-next-line @typescript-eslint/no-unused-vars
   _multiSelect: LcsChipMultiSelectTriggerComponent<UserOption>
): LcsChipMultiSelectTextContentFn<UserOption> {
   return (item: UserOption | null | undefined): string => {
      return `${item?.name}`;
   };
}
